import React from 'react';
import PropTypes from 'prop-types';
import NextLink from 'next/link';
import { Image } from '../../Atoms';

/**
 * Teaser — Overlay variant
 * Uses:
 * - media-element (existing primitive)
 * - media-element--overlay (mode)
 * - media-element--overlay-medium (gradient strength)
 *
 * No new layout systems
 * Works in viewport, cards, highlight, hero, etc.
 */

const TeaserContent = ({ title, subtitle, image }) => (
  <section className="section section-full">
    <div className="section__inner">
      <div className="viewport-90">

        {image && (
          <div className="media-element media-element--overlay media-element--overlay-medium">

            {/* Base media */}
            <Image image={image} fit="cover" />

            {/* Gradient layer */}
            <div className="media-element__gradient" />

            {/* Overlay content */}
            <div className="media-element__content">
              <div className="media-element__inner">
                <div className="stack stack-tight">
                  {title && <div className="text-section-title">{title}</div>}
                  {subtitle && <div className="text-section-support">{subtitle}</div>}
                  <div className="base-link text-label">Learn more →</div>
                </div>
              </div>
            </div>

          </div>
        )}

      </div>
    </div>
  </section>
);

const Teaser = ({ value }) => {
  if (!value) return null;

  const { title, subtitle, image, link } = value;
  const isInternal = link?.startsWith('/') || link?.startsWith('#');

  if (link && isInternal) {
    return (
      <NextLink href={link} className="no-underline">
        <TeaserContent title={title} subtitle={subtitle} image={image} />
      </NextLink>
    );
  }

  if (link) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer" className="no-underline">
        <TeaserContent title={title} subtitle={subtitle} image={image} />
      </a>
    );
  }

  return <TeaserContent title={title} subtitle={subtitle} image={image} />;
};

Teaser.propTypes = {
  value: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    image: PropTypes.object,
    link: PropTypes.string,
  }),
};

TeaserContent.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.object,
};

export default Teaser;
